import { useEffect } from "react";
import Lenis from "lenis";

export function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      smoothTouch: false,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    const id = requestAnimationFrame(raf);

    // Allow anchor scrolling via [data-scroll-to]
    const handler = (e) => {
      const a = e.target.closest("[data-scroll-to]");
      if (!a) return;
      const target = document.querySelector(a.getAttribute("data-scroll-to"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -80 });
      }
    };
    document.addEventListener("click", handler);

    return () => {
      cancelAnimationFrame(id);
      document.removeEventListener("click", handler);
      lenis.destroy();
    };
  }, []);
}
